/**
 * This file contains configuration for `gatsby-plugin-prismic-previews` to
 * support preview sessions from Prismic with drafts and unpublished documents.
 *
 * @see https://prismic.io/docs/technologies/previews-gatsby
 */
import React from 'react'

import { prismicRepo } from '../../prismic-configuration'
import { linkResolver } from './linkResolver'

const PageTemplate = React.lazy(() => import('../templates/page'))
const HomepageTemplate = React.lazy(() => import('../templates/homepage'))
const SolutionsTemplate = React.lazy(() => import('../templates/solutions'))
const StoryPageTemplate = React.lazy(() => import('../templates/story_page'))
const CareersTemplate = React.lazy(() => import('../templates/careers'))
const AboutUsTemplate = React.lazy(() => import('../templates/about_us'))
const TechnologyPageTemplate = React.lazy(() =>
  import('../templates/technology_page'),
)
const PrivacyPageTemplate = React.lazy(() =>
  import('../templates/privacy_page'),
)
const PricePageTemplate = React.lazy(() => import('../templates/price_page'))
const ArticlePageTemplate = React.lazy(() =>
  import('../templates/article_page'),
)
const ArticlesOverviewTemplate = React.lazy(() =>
  import('../templates/articles_overview_page'),
)
const ArticlesSearchTemplate = React.lazy(() =>
  import('../templates/articles_search_page'),
)
const ContactTemplate = React.lazy(() => import('../templates/contact_page'))
const JobDetailsPage = React.lazy(() => import('../templates/job_details_page'))
const AuthorTemplate = React.lazy(() => import('../templates/author_page'))

/**
 * Prismic preview configuration for each repository in your app. This set of
 * configuration objects will be used with the `PrismicPreviewProvider`
 * higher order component.
 *
 * If your app needs to support multiple Prismic repositories, add each of
 * their own configuration objects here as additional elements.
 *
 */
export const repositoryConfigs = [
  {
    repositoryName: prismicRepo,
    linkResolver,
    componentResolver: {
      page: PageTemplate,
      homepage: HomepageTemplate,
      solutions: SolutionsTemplate,
      story_page: StoryPageTemplate,
      careers_page: CareersTemplate,
      about_us_page: AboutUsTemplate,
      technology_page_template: TechnologyPageTemplate,
      privacy_page: PrivacyPageTemplate,
      price_page: PricePageTemplate,
      article_page: ArticlePageTemplate,
      articles_overview_page: ArticlesOverviewTemplate,
      articles_search_page: ArticlesSearchTemplate,
      contact_page: ContactTemplate,
      job_details_page: JobDetailsPage,
      author_page: AuthorTemplate,
    },
  },
]
